import { CountFilterType } from 'modules/queryBuilder/types';
import { CountFilterTypeDropdown } from './CountFilterTypeDropdown';
import { MinMaxInput } from './MinMaxInput';
import { CountFilterWrapper } from './CountFilter.styles';
import { ConditionSingleValueSelectProps, CountFilterProps, CountFilterTypeProps } from '../types';

export const RequirementCountFilter = ({
  value,
  onChange,
  countFilterType,
  setCountFilterType,
  ...props
}: CountFilterProps &
  CountFilterTypeProps &
  Omit<ConditionSingleValueSelectProps<CountFilterType>, 'value' | 'onChange'>) => {
  return (
    <CountFilterWrapper>
      <CountFilterTypeDropdown
        {...props}
        value={countFilterType}
        onChange={(filterType) => {
          if (filterType) setCountFilterType(filterType);
        }}
      />
      <MinMaxInput
        {...props}
        countFilterType={countFilterType}
        setCountFilterType={setCountFilterType}
        value={value}
        onChange={onChange}
      />
    </CountFilterWrapper>
  );
};
